import { Clock, Repeat, CheckCircle, XCircle } from 'lucide-react';

export default function MeetingCard({ meeting, onClick, isSelected }) {
  const statusStyles = {
    scheduled: '',
    completed: 'opacity-60',
    cancelled: 'opacity-40 line-through'
  };

  const statusIcons = {
    completed: <CheckCircle size={12} className="text-success" />,
    cancelled: <XCircle size={12} className="text-text-muted" />
  };

  return (
    <button
      onClick={onClick}
      className={`
        w-full text-left p-3 rounded-lg border transition-all duration-150
        ${isSelected
          ? 'border-accent bg-accent-muted'
          : 'border-border bg-surface-card hover:bg-surface-hover hover:border-border-hover'
        }
        ${statusStyles[meeting.status] || ''}
      `}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <h4 className="text-sm font-medium text-text-primary truncate">
              {meeting.title}
            </h4>
            {meeting.seriesId && (
              <Repeat size={10} className="text-text-tertiary flex-shrink-0" title="Recurring meeting" />
            )}
            {meeting.isVirtual && (
              <span className="text-[9px] px-1.5 py-0.5 bg-surface-hover rounded text-text-tertiary flex-shrink-0">
                Draft
              </span>
            )}
          </div>
          <div className="flex items-center gap-2 mt-1">
            <Clock size={10} className="text-text-tertiary" />
            <span className="text-[11px] text-text-secondary">
              {meeting.startTime} - {meeting.endTime}
            </span>
            {meeting.status !== 'scheduled' && statusIcons[meeting.status]}
          </div>
        </div>
        {meeting.color && (
          <div
            className="w-2 h-2 rounded-full flex-shrink-0 mt-1"
            style={{ backgroundColor: meeting.color }}
          />
        )}
      </div>
      {meeting.agendaItems?.length > 0 && (
        <div className="mt-2 text-[10px] text-text-tertiary">
          {meeting.agendaItems.length} agenda item{meeting.agendaItems.length !== 1 ? 's' : ''}
        </div>
      )}
    </button>
  );
}
